import { BaseUserSchema } from "../../api/schemas/responses/users";
import i18nStore from "../../i18n/store";
import MainAvatar from "../MainAvatar";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material";
import Typography from "@mui/material/Typography";

interface UserPreviewProps {
    user: BaseUserSchema | undefined;
    clickable?: boolean;
    userPost?: string;
}

export default function UserPreview(props: UserPreviewProps) {
    const translations = i18nStore.getTranslations;
    const theme = useTheme();
    if (!props.user) return null;

    return (
        <>
            <Box
                sx={{
                    display: "flex",
                    width: "100%",
                    alignItems: "center",
                    py: "4px",
                    cursor: props.clickable ? "pointer" : "auto",
                }}
            >
                <MainAvatar user={props.user} />
                <Box sx={{ ml: 1 }}>
                    <Typography variant="subtitle2" sx={{ fontSize: "0.9rem" }}>
                        {props.user.name}
                    </Typography>
                    <Typography variant="body2" sx={{ fontSize: "0.8rem", color: theme.palette.grey.A700 }}>
                        {translations.roleEnum[props.userPost || ""] || ""}
                    </Typography>
                </Box>
            </Box>
        </>
    );
}
